module.exports = __webpack_public_path__ + "static/media/opening_02.cdc7a4b1.webp";